import {deserialize, deserializeAs, inheritSerialization} from 'cerialize';
import {Entity} from './entity';
import {User} from './user';
import {Document} from './document/document';

@inheritSerialization(Entity)
export class UserDocument extends Entity {
  @deserialize
  id: number;

  @deserialize
  emetteur: User;

  @deserialize
  destinataire: User;

  @deserialize
  document: Document;
}
